/* eslint-disable react/display-name */
import React from "react";

const UnorderedListItem = React.forwardRef(({ attributes, style, children }, ref) => (
  <li
    ref={ref}
    css={{
      fontSize: 20,
      lineHeight: "34px",
      marginTop: 0,
    }}
    style={style}
    {...attributes}
  >
    {children}
  </li>
));

export default UnorderedListItem;
